import { TranslateService } from "@ngx-translate/core";

import { StatusTimeFormatPipe } from "@commons/pipes/status-time-format.pipe";

import { convertSecondsToHoursAndMinutes } from "./date";

export const prepareTachoDataToDisplay = (data: any, translate: TranslateService, statusTimeFormatPipe: StatusTimeFormatPipe): any => {
    let result = {};
    const keys = Object.keys(data);
    const driveDataList = ['Act_45h', 'Act_DayMax9h',  'Act_DayMax10h', 'Act_DaysOver9h', 'Act_2Weeks'];
    const workDataList = ['Work_6h', 'Work_13h', 'Work_15h', 'Work_Weekly'];
    const restDatList = ['Rest_45min', 'Rest_9hToday', 'Rest_11hToday', 'Rest_Week', 'Rest_2Weeks', 'Rest_PrevWeek'];
    const paramsWithCustomFormatValue = ['Act_DaysOver9h', 'Act_2Weeks', 'Rest_Week', 'Rest_2Weeks', 'Rest_PrevWeek'];

    const getFilterList = (listName: string) => {
        if (listName === 'Drive') return driveDataList;
        if (listName === 'Work') return workDataList;
        if (listName === 'Rest') return restDatList;
        return [];
    };

    const customFormatValueForSelectedParams = (paramName: string, value: any): string => {
        if (paramName === 'Act_2Weeks' || paramName === 'Rest_2Weeks' || paramName === 'Rest_PrevWeek') {
            return convertSecondsToHoursAndMinutes(value).string;
        }
        return value || 0;
    };

    for (const element of keys) {
        const tabParams: Object = data[element];
        const filterList = getFilterList(element);
        const filterParams = filterList.filter(item => item in tabParams);

        result = {
            ...result,
            [element]: filterParams.reduce((prev, curr): any => [
                ...prev,
                { 
                    title: translate.instant(`tacho.${curr}`),
                    value: paramsWithCustomFormatValue.includes(curr) 
                        ? customFormatValueForSelectedParams(curr, data[element][curr])
                        : statusTimeFormatPipe.transform(data[element][curr]),
                }
            ], []),
        };
    }
    return {...result};
};
